import script from "./consultation.vue?vue&type=script&setup=true&lang=js"
export * from "./consultation.vue?vue&type=script&setup=true&lang=js"

import "./consultation.vue?vue&type=style&index=0&id=bbb6d7e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbb6d7e2"]])

export default __exports__